import HelmetLayout from "../../components/GlobalComponents/HelmetLayout";
import Banner from "../../components/Plumbing/Banner/Banner";
import Cards from "../../components/Plumbing/Cards/Cards";
import Conditioning from "../../components/Plumbing/Conditioning/Conditioning";
import List from "../../components/Plumbing/List/List";
import Steps from "../../components/Plumbing/Steps/Steps";

const Plumbing = () => {
    return (
        <HelmetLayout
            name="Plumbing"
            title="Ard Altaamir Plumbing Services: Reliable Team of Experts"
            description="Professional plumbing installation, repair, and maintenance services by Ard Altaamir. Fast, efficient, and guaranteed results."
            route="services/plumbing"
        >
            <Banner />
            <List />
            <Conditioning />
            <Steps />
            <Cards />
        </HelmetLayout>
    );
};

export default Plumbing;
